module.exports = require("dns/promises");